export default [
  {
    date: "2022-10-15",
    location: "Berlin",
    description: "Beer with hodlers",
  },
  {
    date: "2022-10-16",
    location: "Amsterdam",
    description: "Future of NFTs",
  },
  {
    date: "2022-12-15",
    location: "Warsaw",
    description: "Blockchain for good",
  },
  {
    date: "2023-01-02",
    location: "NYC",
    description: "The biggest web3 hackathon",
  },
  {
    date: "2023-01-02",
    location: "Miami",
    description: "Let's talk about DeFi oracles",
  },
];
